import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { useReportCarouselRenderState } from 'src/components/carousels/carousel-render-state';

export function StaffPicksCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: {
      sortBy: `popularSortIdx`,
      staffPicks: true,
    },
    perPage: 25,
  });
  const title = props?.title ?? `Staff Picks`;
  useReportCarouselRenderState({ loading, hasContent: Boolean(products?.length) });

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={title}
      analyticsSection='Staff Picks'
    />
  );
}
